<apx-chart 
  [series]="chartConfig.series" 
  [chart]="chartConfig.chart"
  [tooltip]="chartConfig.tooltip" 
  [stroke]="chartConfig.stroke"
>
</apx-chart>

